import React, {useEffect, useRef, useState} from "react";

const Autocomplete = React.forwardRef((props, ref) => {
    const [index, setIndex] = useState(-1);
    const [prevIndex, setPrevIndex] = useState(null);
    const [inputVal, setInputVal] = useState('');
    const uniqId = "autocomplete-input-"+Math.round(Math.random() * 1000);

    useEffect(() => {
        setIndex(-1);
        setPrevIndex(null);

        let timeout = setTimeout(() => {
            props.search(inputVal, props.section, props.outerIdx, props.pIdx);
        }, 300)

        return () => {
            clearTimeout(timeout);
        };
    }, [inputVal]);

    useEffect(() => {
        window.addEventListener('click', closeAutocompleteResult)

        return () => {
            window.removeEventListener('click', closeAutocompleteResult)
        }
    }, []);

    function closeAutocompleteResult(e) {
        if (! e.target.classList.contains('autocomplete-wrap')) {
            setInputVal('');
        }
    }

    useEffect(() => {
        let ul = document.getElementById(uniqId).nextElementSibling;
        let liList = ul.querySelectorAll('li');

        if (liList && liList.length > 0) {
            let curLi = liList[index];

            if (prevIndex && index > prevIndex) {
                curLi.classList.add('autocomplete-hover');
                if (index > 0) liList[prevIndex].classList.remove('autocomplete-hover');

                if ((curLi.offsetTop + curLi.offsetHeight - ul.scrollTop) >= ul.clientHeight) {
                    ul.scrollBy(0, curLi.offsetHeight);
                }
            } else if (prevIndex && index < prevIndex) {
                curLi.classList.add('autocomplete-hover');
                if (index >= 0) liList[prevIndex].classList.remove('autocomplete-hover');

                if ((curLi.offsetTop - ul.scrollTop) < 0) {
                    ul.scrollBy(0, -curLi.offsetHeight);
                }
            } else {
                liList.forEach((li) => {
                    li.classList.remove('autocomplete-hover');
                })
                if (curLi) curLi.classList.add('autocomplete-hover');
            }
        }
    }, [index])

    function searchHandler(e) {
        setInputVal(e.target.value)
    }

    function keyDownHandler(e) {
        if (e.key === 'ArrowDown') {
            if (index < (props.data.length - 1)) {
                setPrevIndex(index);
                setIndex(index + 1);
            }
        } else if (e.key === 'ArrowUp') {
            if (index > 0) {
                setPrevIndex(index);
                setIndex(index - 1);
            }
        } else if (e.key === 'Enter') {
            getChoice();
            props.clear();
        } else if (e.key === 'Delete') {
            props.clear();
            setInputVal('');
            props.choiceHandler(props.name, props.section, null, props.pIdx, props.outerIdx);
        } else if (e.key === 'Backspace') {
            props.choiceHandler(props.name, props.section, null, props.pIdx, props.outerIdx);
        } else if (props.value && (/^\d$/.test(e.key) || /^[a-z,а-я]$/.test(e.key))) {
            props.clear();
            setInputVal('');
            props.choiceHandler(props.name, props.section, null, props.pIdx, props.outerIdx);
        }
    }

    function overHandler(e) {
        setPrevIndex(null);
        setIndex(Number(e.target.getAttribute('idx')));
    }

    function formatResult(item, val) {
        return  item.replace(new RegExp(val, 'gi'), '<b>$&</b>');
    }

    function getChoice() {
        // let choiceId = Number(e.target.getAttribute('iid'));
        if (index >= 0) {
            let choiceObj = findObj(index);
            console.log(choiceObj)
            props.choiceHandler(props.name, props.section, choiceObj, props.pIdx, props.outerIdx);

            setInputVal('');
        }
    }

    function clickHandler(e) {
        getChoice()
    }

    function findObj(id) {
        // return props.data.find(o => o.id === id);
        return props.data[index];
    }

    function focusOutHandler(e) {
        // setInputVal('');
        props.clear();
    }

    function hackHandler() {
    }

    let items = props.data.map((item, index)=>
        <li
            key={item.id}
            className="text-start"
            iid={item.id}
            idx={index}
            onMouseOver={overHandler}
            dangerouslySetInnerHTML={{__html: formatResult(item.name, inputVal)}}
            onClick={clickHandler}
        >
        </li>
    )

    return(
        <div className='autocomplete-wrap'>
            <input
                name={props.name}
                className="form-control border"
                placeholder="Начните ввод"
                id={uniqId}
                value={props.value ? props.value : inputVal}
                onChange={searchHandler}
                onKeyDown={keyDownHandler}
                onBlur={props.clear ? focusOutHandler : hackHandler}
                ref={ref}
            />

            <ul className='autocomplete shadow-sm bg-body-tertiary rounded'>
                {items}
            </ul>

        </div>
    )
}
)

export default Autocomplete;